// SƠ ĐỒ TỰ DO (đồ thị nhiều mạng) trên trang #/kich-ban/:id (GĐ-A/B1 lượt 2, 07/10/2026) — nối thành phần canvas (so-do-canvas.ts) với API đồ thị. Mọi chủ kịch bản (và Super) sửa được; khi máy chủ tắt cờ (cấu hình) thì chỉ Super sửa, người thường chỉ xem.
// Phần thuần (dữ liệu máy chủ ↔ canvas, cờ theo ô / theo đoạn, kế hoạch, hàng đợi lưu, lưu bố cục có debounce) ở ../kich-ban-do-thi-mo-hinh.ts (có unit test); ở đây chỉ vẽ + nối sự kiện.
//   · Canvas: mọi thao tác hiện NGAY (lạc quan) rồi lưu nền qua HangDoiDoThi (PUT { doThi, phienBan }; thêm ô + nối cạnh cùng nhịp gom thành MỘT lần gửi). Vị trí ô đi đường riêng PUT /bo-cuc (debounce 500 ms, không tăng phiên bản).
//   · Bấm đúp ô (hoặc ô mới có ô bắt buộc trống) → phần "Chi tiết ô" bên cạnh: ô tham số như thẻ bước của kịch bản một đường (cùng các ô chọn / ảnh / video / từ khoá nhiều dòng / chờ giữa các lần), mỗi lần sửa là một việc trong hàng đợi.
//   · Thanh cảnh báo tổng theo ĐOẠN, kế hoạch dự kiến, kết quả chạy thử theo ô / theo đoạn. Mọi chữ người dùng gõ dựng bằng textContent.
import { api, ApiError, errMsg } from "../api";
import { clear, confirmBox, h, toast } from "../dom";
import { store } from "../store";
import type { NutDoThi } from "../../../../src/shared/do-thi";
import { TS_CHO_DEN, TS_CHO_TU } from "../../../../src/shared/cho-giua-lan";
import { giaTriHien, nhanThamSo, thamSoAn } from "../../../../src/shared/tham-so-chon";
import { THAM_SO_XOAY } from "../../../../src/shared/xoay-tu-khoa";
import { taoSoDoCanvas, veCo, type SoDoCanvas } from "./so-do-canvas";
import { loiDeHieu, tenMangDeHieu, type LoiDeHieu } from "../../../../src/shared/loi-de-hieu";
import {
  HangDoiDoThi, LuuBoCuc, boCucTuMayChu, canhBaoHienThi, chiDocCua, chuLapCaSoDo, chuTongUoc, danhMucTuBanDo, danhNhanTheoNut, dtDatCanh, dtDatDanhCho, dtDatLap, dtDatLapCaSoDo, dtDatTanSuat, dtDoiNhieuThamSo, dtDoiNhuong, dtDoiThamSo, dtKhoiPhucNut, dtThemNut, dtTuDuyet, dtXoaNut, keHoachHienThi,
  ketQuaNutHienThi, laNghiCua, taoNutMoi, tenMangCua, tenNutCua, thamSoMacDinhCua, thamSoThieuCua, thanDoThiGuiCoVong, thaoTacCua, tomTatNutCua, tongCoTheoDoan, trangTuMayChu, trangBangNhau, uocNutHienThi,
  laLoiTam, lyDoChuaLuuDoThi, type BanDoWeb, type ChiTietDoThiSv, type CoNut, type KetQuaGuiDt, type KetQuaNutSv, type TrangDoThi, type TrangThaiLuuDt, type ThamSoBanDo,
} from "../kich-ban-do-thi-mo-hinh";
import { oAnhChon, oChonGiaTri } from "./chon-anh";
import { oCauHinhVideo, TEN_THAM_SO_CAU_HINH_VIDEO } from "./video-cau-hinh";
import { oChoGiuaLan, oTuKhoaDong } from "./kich-ban-tu-khoa";
import { canhBaoSo, nhanKhoangSo } from "./kich-ban-so";
import { taoNutHenGio } from "./hen-gio-so-do";

export type ChiTietDoThiTrang = ChiTietDoThiSv & { ten: string };
/** Một dòng "bước đỏ" cho thẻ chạy lượt: `nutId` để nhảy tới ô. */
export interface BuocDoChay { soThuTu: number; tieuDe: string; loi: string; nutId: string }
export interface CtxKhungDoThi {
  alive: () => boolean;
  /** Chi tiết MỚI NHẤT của máy chủ (biến `d` của trang). */
  layD: () => ChiTietDoThiTrang;
  /** Máy chủ trả chi tiết mới (sau PUT / tải lại khi 409) → trang gán `d` rồi vẽ lại các phần khác. */
  nhanD: (moi: ChiTietDoThiTrang) => void;
  banDo: () => BanDoWeb | null;
  /** Hộp lỗi nổi của trang (tiêu đề + câu lỗi); (null, null) = ẩn. */
  baoLoi: (tieuDe: string | null, m: string | null) => void;
  /** Dữ liệu hiển thị của khung vừa đổi (cờ…) → thẻ chạy lượt vẽ lại danh sách bước đỏ. */
  khiDoiHienThi: () => void;
  /** (A4) trạng thái "đã lưu / chưa lưu" của khung vừa đổi → thẻ chạy lượt bật / tắt nút ▶ Chạy (chỉ cập nhật nút, không dựng lại thẻ). */
  khiDoiLuu?: () => void;
}
export interface KhungDoThi {
  ve: () => void;
  huy: () => void;
  /** Đang lưu / còn việc chờ lưu. */
  ban: () => boolean;
  choXong: () => Promise<void>;
  /** Các ô ĐỎ của sơ đồ ĐANG HIỆN (kể cả thao tác còn chờ lưu). */
  buocDo: () => BuocDoChay[];
  /** Chọn ô trên canvas; `moForm` = mở luôn phần chi tiết. */
  nhayToi: (nutId: string, moForm?: boolean) => void;
  /** Số bước rủi ro cao đang đặt TỰ ĐỘNG (nói trong hộp xác nhận Chạy thật). */
  soBuocTuDong: () => number;
  /** (A4) màn hình còn khác bản đã lưu → lý do tắt ▶ Chạy; null = khớp bản lưu. */
  chuaLuu: () => { lyDo: string; hienDong: boolean } | null;
}

const CAU_TRACH_NHIEM = "bot sẽ gửi/đăng mà không hỏi — bạn chịu trách nhiệm nội dung";
/** (08/10/2026) chữ chỉ báo lưu — MỘT chỗ duy nhất, trên thanh công cụ canvas cạnh Hoàn tác / Làm lại. */
const KHOA_TRANG_THAI: Record<TrangThaiLuuDt, string> = { "dang-luu": "⟳ Đang lưu…", "cho-luu": "● Có thay đổi chưa lưu", "loi-thu-lai": "✕ Chưa lưu được — đang thử lại", loi: "✕ Chưa lưu được", "da-luu": "✓ Đã lưu" };
const gioPhut = (ms: number): string => { const d = new Date(ms); return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`; };

export function taoKhungDoThi(box: HTMLElement, ctx: CtxKhungDoThi): KhungDoThi {
  let q: HangDoiDoThi | null = null;
  let luuBC: LuuBoCuc | null = null;
  let canvas: SoDoCanvas | null = null;
  let daHuy = false;
  let moId: string | null = null; // ô đang mở phần chi tiết
  let loiCuoi = false;
  let loiTamHien = false; // hộp lỗi đang báo "Chưa lưu được — đang thử lại"
  let soViec = 0, loiTuViec = 0; // lỗi chỉ tự ẩn khi một việc MỚI HƠN lỗi đó lưu được
  let cuoiD: ChiTietDoThiTrang | null = null; // chi tiết máy chủ trả về ở lần gửi gần nhất (nhận ở khiXong, sau khi hàng đợi đã cập nhật bản đã lưu)
  let co = new Map<string, CoNut[]>();
  let lan = new Map<string, string | null>();
  let henDongBo = 0;
  const giaTriSai = new Map<string, string>(); // data-khoa ô → giá trị máy chủ vừa từ chối (không gửi lại khi rời ô)
  const nhanSai = new Map<string, { nutId: string; nhan: string }>(); // data-khoa ô → ô nào + nhãn (cho dòng lý do tắt ▶ Chạy)
  const pbSai = new Map<string, number>(); // data-khoa ô → phiên bản đã lưu LÚC bị từ chối (sơ đồ đổi sau đó → giá trị đó có thể hợp lệ lại, gõ lại thì gửi)
  let phu: { tom: HTMLElement; co: HTMLElement; kq: HTMLElement } | null = null;

  const chiDoc = (): boolean => chiDocCua(store.user, ctx.layD());
  const layId = (): string => ctx.layD().id;

  // ---------- khung ----------
  const tieuDe = h("h3", {}, "Sơ đồ các bước"); // (08/10/2026) giao diện DUY NHẤT — bỏ chữ "Sơ đồ tự do (thử nghiệm)"
  const trangThaiLuu = h("span", { class: "kb-luu", "data-testid": "dt-luu", role: "status", "aria-live": "polite" });
  const nutLuu = h("button", { type: "button", class: "sdc-btn kb-luu-nut", "data-testid": "dt-luu-nut", title: "Lưu ngay mọi thay đổi đang chờ lên máy chủ" }, "Lưu") as HTMLButtonElement;
  nutLuu.addEventListener("click", () => { if (!q || !q.coThayDoi) return; nutLuu.disabled = true; void q.luuNgay().finally(() => veTrangThaiLuu()); });
  const luuBox = h("span", { class: "kb-luu-box", "data-testid": "dt-luu-box" }, trangThaiLuu, nutLuu);
  const chiDocBox = h("p", { class: "warn-box small", role: "status", "data-testid": "dt-chi-doc", hidden: true }, "Bạn chỉ xem được sơ đồ này — sơ đồ nhiều mạng đang thử nghiệm, chỉ tài khoản Super sửa và chạy được.");
  const ghiChu = h("p", { class: "small muted", "data-testid": "dt-ghi-chu" }, "Kéo ô để sắp xếp, kéo từ chấm bên phải của ô sang ô khác để nối, bấm đúp ô để sửa tham số. Mỗi đường là một chuỗi việc; bot làm một việc một lúc và nhường cho đường khác khi gặp ô Nghỉ bật “điểm nhường”.");
  // (07/10/2026, chỉ còn sơ đồ) bỏ nút "Về danh sách": sơ đồ không bao giờ chuyển ngược về danh sách thẻ
  const congCu = h("div", { class: "row wrap kb-dt-cong-cu", hidden: true });
  const tongBox = h("div", { "data-testid": "dt-tong-box" });
  const canvasHost = h("div", { class: "kb-dt-canvas", "data-testid": "dt-canvas" });
  const ctBox = h("aside", { class: "kb-dt-ct", "data-testid": "dt-chi-tiet", "aria-label": "Chi tiết ô", hidden: true });
  const chinh = h("div", { class: "kb-dt-chinh" }, canvasHost, ctBox);
  const khBox = h("div", { class: "kb-dt-ke-hoach", "data-testid": "dt-ke-hoach" });
  const kqBox = h("div", { class: "kb-dt-kq-box" });
  const the = h("div", { class: "card kb-dt", "data-testid": "dt-card" },
    h("div", { class: "row between wrap kb-dt-dau" }, tieuDe), chiDocBox, ghiChu, congCu, tongBox, chinh, khBox, kqBox);
  box.append(the);

  // ---------- hàng đợi lưu ----------
  function khoiTao(d: ChiTietDoThiTrang): void {
    const id = d.id;
    q = new HangDoiDoThi({
      xacNhan: trangTuMayChu(d),
      phienBan: d.phienBan,
      gui: async (t, pb): Promise<KetQuaGuiDt> => {
        try {
          const moi = await api<ChiTietDoThiTrang>("PUT", `/api/kich-ban/${encodeURIComponent(id)}`, { doThi: thanDoThiGuiCoVong(t), phienBan: pb });
          if (!moi?.doThi) return { ok: false, loi: new Error("Máy chủ trả về sơ đồ không còn là dạng nhiều mạng — tải lại trang") };
          cuoiD = moi;
          return { ok: true, trang: trangTuMayChu(moi), phienBan: moi.phienBan };
        } catch (e) {
          if (e instanceof ApiError && e.code === "conflict") {
            try { cuoiD = await api<ChiTietDoThiTrang>("GET", `/api/kich-ban/${encodeURIComponent(id)}`); } catch { cuoiD = null; }
            return { ok: false, loi: e, xungDot: true };
          }
          return { ok: false, loi: e, tam: laLoiTam(e) }; // 500 / mất mạng → GIỮ thay đổi, tự thử lại; 400 → máy chủ từ chối nội dung
        }
      },
      khiDoi: () => { if (!daHuy) { veTrangThaiLuu(); lenLichDongBo(); } },
      khiXong: () => { loiCuoi = false; if (loiTamHien) { loiTamHien = false; ctx.baoLoi(null, null); } const m = cuoiD; cuoiD = null; if (m && !daHuy) ctx.nhanD(m); }, // lỗi tạm đã qua → lưu được → ẩn hộp lỗi
      khiLoi: (e, c) => {
        loiTuViec = soViec;
        const ds = [...new Set(c.viec.filter(Boolean))];
        const dsChu = ds.length ? ` Thay đổi chưa lưu: ${ds.slice(0, 8).join(", ")}${ds.length > 8 ? ` và ${ds.length - 8} thay đổi khác` : ""}.` : "";
        if (c.tam) {
          loiCuoi = false; loiTamHien = true;
          ctx.baoLoi("Chưa lưu được — đang thử lại", `${errMsg(e)}. Thay đổi vẫn GIỮ trên sơ đồ, máy tự lưu lại sau ${Math.max(1, Math.round((c.thuLaiSauMs ?? 0) / 1000))} giây — hoặc bấm “Thử lưu lại”.${dsChu}`);
          return;
        }
        loiCuoi = true;
        if (c.xungDot) {
          toast(`Kịch bản vừa đổi ở nơi khác — đã tải bản mới.${dsChu}`, "warn", 8000);
          const m = cuoiD; cuoiD = null;
          if (m && q) {
            q.datXacNhan(trangTuMayChu(m), m.phienBan); ctx.nhanD(m);
            giaTriSai.clear(); pbSai.clear(); nhanSai.clear(); // (A4) bản mới nạp về: ô đang mở hiện đúng giá trị mới, không giữ chữ cũ + viền đỏ — KHÔNG cần F5
            veLaiForm();
          }
        }
        ctx.baoLoi(c.xungDot ? "Chưa lưu được — bản trên máy chủ vừa đổi" : "Chưa lưu được — sơ đồ đã trả về như trước", `${errMsg(e)}${c.xungDot ? `.${dsChu} Hãy làm lại các thay đổi đó trên bản mới.` : ""}`);
      },
    });
    luuBC = new LuuBoCuc({
      biet: boCucTuMayChu(d),
      gui: async (nut) => { await api("PUT", `/api/kich-ban/${encodeURIComponent(id)}/bo-cuc`, { nut }); },
      khiLoi: (e) => toast(`Chưa lưu được vị trí các ô: ${errMsg(e)}`, "warn"),
    });
  }
  /** Xếp một việc sửa đồ thị; trả false nếu không áp được (không gửi gì). */
  function xep(v: { lam: (t: TrangDoThi) => TrangDoThi | null; ten: string; xong?: () => void; loi?: (e: unknown) => void }): boolean {
    if (!q || chiDoc()) return false;
    const so = ++soViec;
    const ok = q.them({ lam: v.lam, ten: v.ten, xong: () => { if (so > loiTuViec) ctx.baoLoi(null, null); v.xong?.(); }, loi: (e) => v.loi?.(e) });
    if (!ok) soViec--;
    return ok;
  }
  function veTrangThaiLuu(): void {
    const tt: TrangThaiLuuDt = !q ? "da-luu" : q.trangThai === "da-luu" && loiCuoi ? "loi" : q.trangThai;
    const so = q?.soCho ?? 0;
    trangThaiLuu.dataset.trangThai = tt;
    trangThaiLuu.textContent = tt === "da-luu" && q?.luuLuc ? `✓ Đã lưu lúc ${gioPhut(q.luuLuc)}` : `${KHOA_TRANG_THAI[tt]}${(tt === "dang-luu" || tt === "loi-thu-lai") && so > 1 ? ` (${so} thay đổi)` : ""}`;
    trangThaiLuu.title = tt === "dang-luu" ? "Thay đổi đã hiện trên sơ đồ, đang lưu lên máy chủ" : tt === "loi" ? "Lần lưu gần nhất bị từ chối — sơ đồ đã trả về bản trên máy chủ"
      : tt === "loi-thu-lai" ? "Chưa lưu được (mất mạng / máy chủ lỗi) — thay đổi vẫn giữ trên sơ đồ, máy tự thử lại" : tt === "cho-luu" ? "Có thay đổi chưa lên máy chủ" : "Sơ đồ trên màn hình đã lưu trên máy chủ";
    nutLuu.textContent = tt === "loi-thu-lai" ? "Thử lưu lại" : "Lưu";
    nutLuu.disabled = !q?.coThayDoi || tt === "dang-luu";
    luuBox.hidden = chiDoc();
    canvasHost.setAttribute("aria-busy", q?.ban ? "true" : "false");
    ctx.khiDoiLuu?.();
  }
  /** (A4) ▶ Chạy tắt khi màn hình còn khác bản đã lưu — việc chờ lưu / chờ thử lại / ô còn giữ giá trị máy chủ từ chối (chỉ tính ô của ô còn tồn tại trên sơ đồ). */
  function chuaLuu(): { lyDo: string; hienDong: boolean } | null {
    if (!q || chiDoc()) return null;
    const con = new Set(q.hienThi().nut.map((n) => n.id));
    const tenOSai = [...new Set([...giaTriSai.keys()].map((k) => nhanSai.get(k)).filter((v): v is { nutId: string; nhan: string } => !!v && con.has(v.nutId)).map((v) => v.nhan))];
    return lyDoChuaLuuDoThi({ trangThai: q.trangThai, coThayDoi: q.coThayDoi, tenOSai });
  }
  /** F5 / đóng tab khi còn thay đổi chưa lưu → trình duyệt hỏi lại (không tự mất thao tác). */
  const canhBaoRoi = (e: BeforeUnloadEvent): void => { if (!daHuy && q?.coThayDoi) { e.preventDefault(); e.returnValue = ""; } };
  addEventListener("beforeunload", canhBaoRoi);

  // ---------- canvas ----------
  const cb = {
    thayDoiCanh: (canh: { tu: string; den: string }[]): void => { xep({ lam: (t) => dtDatCanh(t, canh), ten: "nối các ô" }); },
    thayDoiBoCuc: (bc: Record<string, { x: number; y: number }>): void => { luuBC?.dat(bc); },
    moChiTiet: (id: string): void => moForm(id),
    themNut: (yc: { thaoTac?: string; nenTang?: string; sauNutId?: string }): NutDoThi | null => {
      if (!q) return null;
      const t = q.hienThi();
      const nguon = yc.sauNutId ? t.nut.find((n) => n.id === yc.sauNutId) : undefined;
      const mang = yc.nenTang ?? nguon?.nenTang ?? t.nenTang;
      const def = yc.thaoTac ? thaoTacCua(ctx.banDo(), mang, yc.thaoTac) : undefined;
      if (!def) { toast("Chọn một thao tác trong menu để thêm ô", "warn"); return null; }
      // (09/10/2026, người dùng chốt) ô RỦI RO CAO (bình luận / trả lời / đăng / thích / theo dõi…) thêm mới bật sẵn "Tự động (không cần duyệt)"; tắt tay được.
      const moi: NutDoThi = { ...taoNutMoi(t, def.ma, thamSoMacDinhCua(def), mang), ...(def.ruiRo === "cao" ? { tuDuyet: true } : {}) };
      if (!xep({ lam: (x) => dtThemNut(x, moi), ten: `ô “${def.tenNgan}”` })) return null;
      if (thamSoThieuCua(ctx.banDo(), t.nenTang, moi).length) window.setTimeout(() => { if (!daHuy && q?.hienThi().nut.some((n) => n.id === moi.id)) moForm(moi.id); }, 0); // ô bắt buộc còn trống → mở "Sửa tham số"
      return moi;
    },
    xoaNut: (id: string): void => { xep({ lam: (t) => dtXoaNut(t, id), ten: "việc xoá ô" }); if (moId === id) dongForm(); },
    khoiPhucNut: (n: NutDoThi): void => { xep({ lam: (t) => dtKhoiPhucNut(t, n), ten: "việc hoàn tác xoá ô" }); },
    nhanBan: (id: string): NutDoThi | null => {
      if (!q) return null;
      const t = q.hienThi();
      const goc = t.nut.find((n) => n.id === id);
      if (!goc) return null;
      const moi: NutDoThi = { ...taoNutMoi(t, goc.thaoTac, { ...goc.thamSo }, goc.nenTang ?? t.nenTang), ...(goc.tuDuyet ? { tuDuyet: true } : {}) };
      return xep({ lam: (x) => dtThemNut(x, moi), ten: "bản sao của ô" }) ? moi : null;
    },
    doiNhuong: (id: string): void => { xep({ lam: (t) => dtDoiNhuong(t, id), ten: "điểm nhường" }); },
    // (07/10/2026) vòng lặp "Quay lại" + Lặp cả sơ đồ — lưu cùng sơ đồ (PUT doThi.lap / lapCaSoDo)
    thayDoiLap: (lap: NonNullable<TrangDoThi["lap"]>): void => { xep({ lam: (t) => dtDatLap(t, lap), ten: "vòng lặp" }); },
    thayDoiLapCaSoDo: (lc: TrangDoThi["lapCaSoDo"] | null): void => { xep({ lam: (t) => dtDatLapCaSoDo(t, lc ?? null), ten: "lặp cả sơ đồ" }); },
    // (08/10/2026, đợt A) bước Nghỉ "Dành cho" nhánh khác + tần suất theo bước — lưu cùng sơ đồ (trường của nút)
    datDanhCho: (id: string, v: string | null): void => { xep({ lam: (t) => dtDatDanhCho(t, id, v), ten: "bước Nghỉ dành cho nhánh" }); },
    // (08/10/2026) máy chủ tự LAN NGƯỢC tần suất sang bước tạo dữ liệu ngay trước (do-thi.ts lanTanSuatNguoc) — lưu xong thì báo bước nào vừa nhận cùng tần suất
    datTanSuat: (id: string, v: NutDoThi["tanSuat"] | null): void => {
      const truoc = new Map((q?.hienThi().nut ?? []).map((n) => [n.id, JSON.stringify(n.tanSuat ?? null)] as const));
      xep({ lam: (t) => dtDatTanSuat(t, id, v), ten: "tần suất của bước", xong: () => {
        if (!v || !q || daHuy) return;
        const xn = q.xacNhan;
        const lan = xn.nut.filter((n) => n.id !== id && truoc.get(n.id) === "null" && JSON.stringify(n.tanSuat ?? null) === JSON.stringify(v));
        const goc = xn.nut.find((n) => n.id === id);
        if (!lan.length || !goc) return;
        const chu = v.kieu === "dau_ngay" ? "chỉ vòng đầu mỗi ngày" : `cứ ${v.n} ngày một lần`;
        toast(`Đã áp “${chu}” cho cả bước ${lan.map((n) => `“${tenNutCua(ctx.banDo(), xn.nenTang, n)}”`).join(", ")} vì bước “${tenNutCua(ctx.banDo(), xn.nenTang, goc)}” cần dữ liệu của bước trước nó (phải chạy cùng một đoạn)`, "warn");
      } });
    },
  };
  // (đợt A) nút đỏ "Hẹn giờ chạy" ở góc dưới phải khung vẽ
  const henGio = taoNutHenGio({ kbId: () => layId(), chuKb: () => ctx.layD().ownerId,choChayThat: () => (ctx.layD() as unknown as { choChayThat?: { duoc: boolean; lyDo: string } }).choChayThat ?? { duoc: false, lyDo: "kịch bản chưa sẵn sàng" }, chiDoc: () => chiDoc() });
  /** Ước lượng của ô cho canvas: Nghỉ tính ngay từ tham số đang hiện; việc khác theo máy chủ (cập nhật khi lưu xong). */
  const uocCua = (n: NutDoThi): { tuS: number; denS: number } | null => uocNutHienThi(q?.hienThi() ?? null, ctx.layD(), ctx.banDo(), n);
  /** (08/10/2026) Ô lỗi trong lần chạy gần nhất (máy chủ ketQuaNut — lần chạy THẬT đúng phiên bản đoạn được ưu tiên) → câu dễ hiểu cho dấu ✗ đỏ trên ô. */
  const loiCuaNut = (id: string): LoiDeHieu | null => {
    const k = ctx.layD().doThi.ketQuaNut?.[id];
    if (k?.trangThai !== "loi") return null;
    const t = q?.hienThi(); const n = t?.nut.find((x) => x.id === id);
    const nt = n?.nenTang ?? t?.nenTang ?? ctx.layD().doThi.nenTang;
    return loiDeHieu(k.lyDo, { mang: tenMangCua(ctx.banDo(), nt) || tenMangDeHieu(nt), buoc: n ? tenNutCua(ctx.banDo(), nt, n) : null });
  };
  const loiChayCua = (id: string): string | null => { const l = loiCuaNut(id); return l ? `${l.cau}. Cách sửa: ${l.cachSua}` : null; };
  /** Ô lỗi ở "Kết quả theo ô" / chi tiết ô: câu dễ hiểu + Cách sửa; chữ thô của bot trong "Chi tiết kỹ thuật" thu gọn. */
  const loiOEl = (id: string): HTMLElement[] => {
    const l = loiCuaNut(id);
    if (!l) return [];
    return [h("span", { "data-testid": "dt-kq-cau" }, l.cau), h("div", { class: "small", "data-testid": "dt-kq-cach-sua" }, h("b", {}, "Cách sửa: "), l.cachSua),
      l.kyThuat ? h("details", { class: "kb-loi-ky-thuat", "data-testid": "dt-kq-ky-thuat" }, h("summary", {}, "Chi tiết kỹ thuật"), h("code", {}, l.kyThuat)) : null].filter((x): x is HTMLElement => !!x);
  };
  function datCanvas(d: ChiTietDoThiTrang): void {
    const t = q!.hienThi();
    const banDo = ctx.banDo();
    co = canhBaoHienThi(t, d, banDo);
    lan = danhNhanTheoNut(d);
    canvas = taoSoDoCanvas(canvasHost, {
      nut: t.nut, canh: t.canh, boCuc: boCucTuMayChu(d), nenTangMacDinh: t.nenTang, chiDoc: chiDoc(), danhMuc: danhMucTuBanDo(banDo),
      lap: t.lap ?? [], lapCaSoDo: t.lapCaSoDo ?? null, uocNut: uocCua, tongUoc: () => chuTongUoc(ctx.layD()), henGio: henGio.el, luuEl: luuBox,
      thaoTacMang: (_m, n) => n?.nenTang ?? undefined,
      tenNut: (n) => tenNutCua(ctx.banDo(), q?.hienThi().nenTang ?? t.nenTang, n),
      tomTatNut: (n) => tomTatNutCua(ctx.banDo(), q?.hienThi().nenTang ?? t.nenTang, n),
      laNghi: (n) => laNghiCua(ctx.banDo(), q?.hienThi().nenTang ?? t.nenTang, n),
      canhBao: (id) => co.get(id) ?? [],
      loiChay: (id) => loiChayCua(id),
      danhNhan: (id) => lan.get(id) ?? null,
      cb,
    });
  }
  /** Đưa bản đang hiện (lạc quan) vào canvas + vẽ lại các phần phụ. Hoãn tới sau nhịp hiện tại: canvas gọi cb.themNut rồi MỚI thêm ô vào bản của nó — đưa ô vào trước đó sẽ bị coi là trùng mã. */
  function lenLichDongBo(): void {
    if (henDongBo) return;
    henDongBo = window.setTimeout(() => { henDongBo = 0; if (!daHuy) dongBo(); }, 0);
  }
  function dongBo(): void {
    if (!q || !canvas) return;
    const d = ctx.layD();
    const t = q.hienThi();
    const banDo = ctx.banDo();
    co = canhBaoHienThi(t, d, banDo);
    lan = danhNhanTheoNut(d);
    canvas.capNhat({
      nut: t.nut, canh: t.canh, nenTangMacDinh: t.nenTang, chiDoc: chiDoc(), danhMuc: danhMucTuBanDo(banDo),
      lap: t.lap ?? [], lapCaSoDo: t.lapCaSoDo ?? null, uocNut: uocCua, tongUoc: () => chuTongUoc(ctx.layD()),
      thaoTacMang: (_m, n) => n?.nenTang ?? undefined,
      tenNut: (n) => tenNutCua(ctx.banDo(), t.nenTang, n),
      tomTatNut: (n) => tomTatNutCua(ctx.banDo(), t.nenTang, n),
      laNghi: (n) => laNghiCua(ctx.banDo(), t.nenTang, n),
      canhBao: (id) => co.get(id) ?? [],
      loiChay: (id) => loiChayCua(id),
      danhNhan: (id) => lan.get(id) ?? null,
    });
    veTong(); veKeHoach(); veKetQua(); veChiTietPhu(); veCongCu();
    ctx.khiDoiHienThi();
  }

  // ---------- thanh cảnh báo tổng ----------
  function veTong(): void {
    clear(tongBox);
    if (!q) return;
    const d = ctx.layD();
    const t = q.hienThi();
    const tong = tongCoTheoDoan(co, d, ctx.banDo(), t.nut);
    if (!tong.do && !tong.vang) return;
    const so = [tong.do ? `${tong.do} ô đỏ` : null, tong.vang ? `${tong.vang} ô vàng` : null].filter(Boolean).join(", ");
    const nhom = tong.nhom.map((g) => h("div", { class: "kb-dt-nhom", "data-testid": "dt-co-nhom", dataset: { doan: g.doanId ?? "" } },
      h("span", { class: "small kb-dt-nhom-ten" }, `${g.nhan}:`),
      ...g.ds.map((x) => {
        const nutBam = h("button", { type: "button", class: `mini kb-co-nhay kb-co-nhay-${x.muc}`, "data-testid": "dt-co-nhay", dataset: { nut: x.nutId, muc: x.muc }, "aria-label": `Tới ô “${x.ten}” (${x.muc === "do" ? "đỏ — thiếu đầu vào" : "vàng — nên xem lại"})`, title: `Chọn ô “${x.ten}” trên sơ đồ` },
          h("span", { class: "kb-co-bieu", "aria-hidden": "true" }, veCo(x.muc), " "), x.ten);
        nutBam.addEventListener("click", () => nhayToi(x.nutId));
        return nutBam;
      })));
    tongBox.append(h("div", { class: `kb-co-tong ${tong.do ? "co-do" : "co-vang"}`, role: "status", "data-testid": "dt-tong-co", dataset: { do: String(tong.do), vang: String(tong.vang) } },
      h("p", { class: "kb-co-tong-chu" }, h("span", { class: "kb-co-bieu", "aria-hidden": "true" }, veCo(tong.do ? "do" : "vang")), " ", h("b", { "data-testid": "dt-tong-co-so" }, so),
        h("span", { class: "small" }, tong.do ? " — ô đỏ thiếu đầu vào nên SẼ KHÔNG CHẠY (bấm Chạy bị từ chối) tới khi điền đủ hoặc sửa lại" : " — ô vàng vẫn chạy được, chỉ nên xem lại")),
      h("div", { class: "kb-dt-nhom-hang" }, ...nhom)),
      // chú giải biểu tượng nằm NGOÀI hộp trạng thái (hộp chỉ nói số ô đỏ / vàng thật)
      h("p", { class: "kb-dt-chu-giai", "data-testid": "dt-chu-giai" }, "Chú giải:", h("span", {}, veCo("do"), "ô đỏ — thiếu đầu vào, sẽ không chạy"), h("span", {}, veCo("vang"), "ô vàng — nên xem lại"), h("span", {}, "✕ góc trên phải ô = xoá ô")));
  }
  function nhayToi(nutId: string, mo = false): void {
    canvas?.chonNut(nutId);
    if (mo) moForm(nutId);
  }

  // ---------- kế hoạch dự kiến / kết quả chạy thử ----------
  function veKeHoach(): void {
    clear(khBox);
    const d = ctx.layD();
    const kh = keHoachHienThi(d, ctx.banDo());
    khBox.append(h("h4", {}, "Kế hoạch dự kiến"),
      h("p", { class: "small muted" }, "Bot làm một đoạn một lúc; khi một đường nghỉ (ô Nghỉ có điểm nhường) thì đường khác làm tiếp. Mỗi đoạn là một chuỗi ô liền nhau cùng một mạng."));
    if (!kh.length) { khBox.append(h("p", { class: "small muted", "data-testid": "dt-ke-hoach-trong" }, d.loiSoDo?.length ? `Chưa dựng được kế hoạch: ${d.loiSoDo[0]}` : "Chưa có kế hoạch (sơ đồ chưa hợp lệ)")); return; }
    const tong = chuTongUoc(d), lc = chuLapCaSoDo(q?.hienThi().lapCaSoDo ?? d.doThi.lapCaSoDo ?? null);
    if (tong || lc) khBox.append(h("p", { class: "small", "data-testid": "dt-tong-uoc" }, [lc, tong ? `Tổng thời gian ước chừng: ${tong.replace(/^Cả sơ đồ /, "")}` : ""].filter(Boolean).join(" · ")));
    const ds = h("div", { class: "kb-dt-duongs" });
    for (const du of kh) {
      ds.append(h("div", { class: "kb-dt-duong", "data-testid": "dt-duong", dataset: { duong: du.id } },
        h("h5", {}, du.ten),
        h("ol", {}, ...du.muc.map((m) => h("li", { class: `kb-dt-muc kb-dt-muc-${m.kieu}`, "data-testid": "dt-muc", dataset: { kieu: m.kieu } },
          h("span", { class: "kb-dt-muc-chu" }, m.chu), m.uoc ? h("span", { class: "small muted" }, ` · ${m.uoc}`) : null,
          m.chip ? h("span", { class: `tag kb-dt-chip kb-dt-chip-${m.chip === "Lần chạy gần nhất đạt" ? "ok" : m.chip === "Lần chạy gần nhất lỗi" ? "loi" : "khac"}`, "data-testid": "dt-chip" }, m.chip) : null)))));
    }
    khBox.append(ds);
  }
  function veKetQua(): void {
    clear(kqBox);
    const d = ctx.layD();
    const ds = ketQuaNutHienThi(d, ctx.banDo(), q?.hienThi().nut);
    if (!ds.length) return;
    kqBox.append(h("details", { class: "kb-dt-kq", "data-testid": "dt-ket-qua", open: true }, h("summary", {}, `Kết quả lần chạy gần nhất theo ô (${ds.length})`),
      h("ul", {}, ...ds.map((r) => h("li", { class: `kb-kq ${r.trangThai === "ok" ? "ok" : r.trangThai === "loi" ? "err" : "muted"}`, "data-testid": "dt-kq", dataset: { nut: r.nutId, trangThai: r.trangThai } },
        h("span", { "aria-hidden": "true" }, r.trangThai === "ok" ? "✓ " : r.trangThai === "loi" ? "✗ " : "… "), h("b", {}, r.ten),
        ...(r.trangThai === "loi" ? [" — lỗi: ", ...loiOEl(r.nutId)] : [` — ${r.chu}`]), cauMauEl(d.doThi.ketQuaNut[r.nutId]))))));
  }
  /** (08/10/2026, chỉ còn sơ đồ) Câu AI soạn của ô trong lần chạy gần nhất — máy chủ trả sẵn (ketQuaNut.cauMau) như thẻ bước cũ (kb-cau-mau) nhưng trang sơ đồ chưa hiện. */
  function cauMauEl(k: KetQuaNutSv | undefined): HTMLElement | null {
    if (!k?.cauMau?.length) return null;
    return h("div", { class: "kb-cau-mau" }, h("span", { class: "small muted", "data-testid": "dt-cau-nhan" }, k.cauDaSua?.length ? "Câu đã đăng (đã sửa khi duyệt):" : "Câu AI soạn:"),
      h("ul", {}, ...k.cauMau.map((c) => h("li", { "data-testid": "dt-cau-mau", ...(k.cauDaSua?.includes(c) ? { class: "kb-cau-da-sua", title: "Bạn đã sửa câu AI soạn trước khi duyệt — đây là câu bot đã đăng" } : {}) }, c))));
  }
  function veCongCu(): void {
    chiDocBox.hidden = !chiDoc();
  }

  // ---------- chi tiết ô ----------
  function dongForm(): void {
    moId = null; phu = null;
    delete ctBox.dataset.nut;
    ctBox.hidden = true;
    clear(ctBox);
    chinh.classList.remove("co-ct");
  }
  function moForm(id: string): void {
    if (!q) return;
    const n = q.hienThi().nut.find((x) => x.id === id);
    if (!n) return;
    moId = id;
    dungForm(n);
    ctBox.dataset.nut = id;
    ctBox.hidden = false;
    chinh.classList.add("co-ct");
    ctBox.scrollIntoView({ block: "nearest", behavior: "instant" as ScrollBehavior });
  }
  function veLaiForm(tieuDiem?: string): void {
    if (!moId || !q) return;
    const n = q.hienThi().nut.find((x) => x.id === moId);
    if (!n) { dongForm(); return; }
    dungForm(n);
    if (tieuDiem) ctBox.querySelector<HTMLElement>(`[data-khoa="${CSS.escape(tieuDiem)}"]`)?.focus({ preventScroll: true });
  }
  /** Phần chỉ-đọc của form (tóm tắt, cờ, kết quả) cập nhật theo dữ liệu mới mà không dựng lại ô đang gõ. */
  function veChiTietPhu(): void {
    if (!moId || !q || !phu) return;
    const t = q.hienThi();
    const n = t.nut.find((x) => x.id === moId);
    if (!n) { dongForm(); return; }
    phu.tom.textContent = tomTatNutCua(ctx.banDo(), t.nenTang, n) || "—";
    phu.co.replaceChildren(...(co.get(n.id) ?? []).map((c) => h("p", { class: `kb-co-ly kb-co-ly-${c.muc}`, "data-testid": "dt-ct-co", dataset: { muc: c.muc } }, h("span", { class: "kb-co-bieu", "aria-hidden": "true" }, veCo(c.muc)), ` ${c.loi}`)));
    const k = ctx.layD().doThi.ketQuaNut[n.id];
    phu.kq.replaceChildren(...(k ? [k.trangThai === "loi"
      ? h("div", { class: "kb-kq err", "data-testid": "dt-ct-kq" }, "✗ Lần chạy gần nhất: lỗi — ", ...loiOEl(n.id))
      : h("p", { class: `kb-kq ${k.trangThai === "ok" ? "ok" : "muted"}`, "data-testid": "dt-ct-kq" }, `${k.trangThai === "ok" ? "✓" : "…"} Lần chạy gần nhất: ${k.trangThai === "ok" ? "đạt" : k.trangThai}`)] : []));
  }
  function luuTs(id: string, doi: Record<string, string>, nhan: string, khoaSai?: string, giaTri?: string, inp?: HTMLInputElement): void {
    const khongDoi = !xep({
      lam: (t) => dtDoiNhieuThamSo(t, id, doi), ten: `“${nhan}”`,
      xong: () => { if (khoaSai) { giaTriSai.delete(khoaSai); inp?.classList.remove("kb-sai"); } },
      loi: () => { if (khoaSai && giaTri !== undefined) { giaTriSai.set(khoaSai, giaTri); nhanSai.set(khoaSai, { nutId: id, nhan }); inp?.classList.add("kb-sai"); } },
    });
    // giá trị gõ lại đúng bằng bản đang lưu (vd sửa lại chữ vừa bị từ chối về như cũ): không có gì để gửi — coi như xong, bỏ viền đỏ + lỗi cũ
    if (khongDoi && q && !chiDoc()) { if (khoaSai) { giaTriSai.delete(khoaSai); inp?.classList.remove("kb-sai"); } ctx.baoLoi(null, null); loiCuoi = false; q.boQuaLoi(); veTrangThaiLuu(); }
  }
  function dungForm(n: NutDoThi): void {
    if (!q) return;
    clear(ctBox);
    const t = q.hienThi();
    const banDo = ctx.banDo();
    const mang = n.nenTang ?? t.nenTang;
    const def = thaoTacCua(banDo, mang, n.thaoTac);
    const chiXem = chiDoc();
    const d = ctx.layD();
    const dong = h("button", { type: "button", class: "kb-noi-x", "data-testid": "dt-chi-tiet-dong", "aria-label": "Đóng phần chi tiết ô", title: "Đóng phần chi tiết ô" }, "×");
    dong.addEventListener("click", () => dongForm());
    const tom = h("p", { class: "small", "data-testid": "dt-ct-tom-tat" });
    const coBox = h("div", {});
    const kqBoxCt = h("div", {});
    phu = { tom, co: coBox, kq: kqBoxCt };
    ctBox.append(h("div", { class: "row between kb-dt-ct-dau" }, h("h4", { "data-testid": "dt-ct-ten" }, `${tenNutCua(banDo, t.nenTang, n)} · ${tenMangCua(banDo, mang)}`), dong), tom, coBox);
    if (!def) { ctBox.append(h("p", { class: "err small" }, `Thao tác “${n.thaoTac}” không có trong bản đồ của mạng này.`)); return; }
    if (def.ruiRo === "cao") ctBox.append(congTac(n, def.tenNgan, chiXem));
    const luoi = h("div", { class: "kb-ts-luoi kb-dt-luoi" });
    const gtTat = n.thamSo;
    for (const p of def.thamSo.filter((x) => !thamSoAn(x.ten, gtTat))) { const o = oThamSo(n, p, mang, d.ownerId ?? "", chiXem); if (o) luoi.append(o); }
    ctBox.append(luoi, kqBoxCt);
    veChiTietPhu();
  }
  function congTac(n: NutDoThi, tenNgan: string, chiXem: boolean): HTMLElement {
    const bat = n.tuDuyet === true;
    const o = h("input", { type: "checkbox", role: "switch", class: "kb-cong-tac", "data-testid": "dt-tu-duyet", "data-khoa": `dt:${n.id}:tu-duyet`, checked: bat, disabled: chiXem, "aria-checked": bat ? "true" : "false", "aria-label": `Ô “${tenNgan}”: tự động, không cần duyệt khi chạy thật` });
    o.addEventListener("change", () => void (async () => {
      const b = o.checked;
      if (b && !(await confirmBox({ title: "Bật tự động (không cần duyệt)?", okText: "Bật tự động", danger: true, text: `Ô “${tenNgan}” sẽ chạy TỰ ĐỘNG. Khi chạy thật, ${CAU_TRACH_NHIEM}. Áp dụng từ lần chạy sau.` }))) { o.checked = false; return; }
      if (!xep({ lam: (t) => dtTuDuyet(t, n.id, b), ten: "công tắc Tự động", xong: () => toast(b ? "Ô này chạy TỰ ĐỘNG từ lần chạy sau" : "Ô này trở lại CẦN DUYỆT"), loi: () => { o.checked = !b; } })) o.checked = !b;
    })());
    return h("label", { class: `kb-tu-duyet${bat ? " bat" : ""}`, title: bat ? "Đang TỰ ĐỘNG: chạy thật gửi/đăng không hỏi duyệt. Bỏ chọn để trở lại cần duyệt." : `Mặc định CẦN DUYỆT. Chọn để chạy thật không hỏi duyệt ô này (${CAU_TRACH_NHIEM}).` }, o, h("span", {}, "Tự động (không cần duyệt)"));
  }
  /** Ô tham số của một ô: cùng bộ ô với thẻ bước của kịch bản một đường (chữ / số, chọn, ảnh, video, từ khoá nhiều dòng, chờ giữa các lần). */
  function oThamSo(n: NutDoThi, p: ThamSoBanDo, mang: string, ownerId: string, chiXem: boolean): HTMLElement | null {
    const khoa = `dt:${layId()}:${n.id}:ts:${p.ten}`;
    const gt = n.thamSo[p.ten] ?? "";
    const dinh = { ten: p.ten, nhan: p.nhan, moTa: p.moTa, kieu: p.kieu, batBuoc: p.batBuoc, min: p.min, max: p.max, luaChon: p.luaChon, macDinh: p.macDinh, giaTri: gt };
    if (p.ten === TS_CHO_DEN) return null;
    if (chiXem) return h("label", { class: "f kb-ts" }, h("span", {}, nhanThamSo(p.nhan)), h("input", { value: p.ten === "tu_khoa" ? gt : giaTriHien(p.ten, gt), disabled: true, "data-testid": `dt-ts-${p.ten}`, title: p.moTa }));
    if (p.ten === TS_CHO_TU) {
      return oChoGiuaLan({ khoa, nenTang: mang, thaoTac: n.thaoTac, tu: gt, den: n.thamSo[TS_CHO_DEN] ?? "", testPrefix: "dt-ts", onDoi: (tu, den) => luuTs(n.id, { [TS_CHO_TU]: tu, [TS_CHO_DEN]: den }, "Chờ giữa các lần") });
    }
    if (p.ten === "tu_khoa") {
      const coCauHinh = !!thaoTacCua(ctx.banDo(), mang, n.thaoTac)?.thamSo.some((x) => x.ten === "tu_khoa_cau_hinh");
      return oTuKhoaDong({ khoa, tuKhoa: gt, cauHinh: n.thamSo.tu_khoa_cau_hinh ?? "", coCauHinh, nenTang: mang, thaoTac: n.thaoTac, testPrefix: "dt-ts", onDoi: (tk, ch) => luuTs(n.id, { tu_khoa: tk, ...(coCauHinh ? { tu_khoa_cau_hinh: ch } : {}) }, "Từ khoá") });
    }
    if (p.ten === TEN_THAM_SO_CAU_HINH_VIDEO) return oCauHinhVideo({ ten: p.ten, nhan: p.nhan, giaTri: gt }, { testid: `dt-ts-${p.ten}`, khoa, nenTang: mang, onDoi: (v) => { if (v !== gt) { luuTs(n.id, { [p.ten]: v }, nhanThamSo(p.nhan)); veLaiForm(khoa); } } });
    if (p.ten === "anh_chon") return oAnhChon(dinh, gt, { testid: `dt-ts-${p.ten}`, khoa, ownerId, onDoi: (v) => { if (v !== gt) { luuTs(n.id, { [p.ten]: v }, nhanThamSo(p.nhan)); veLaiForm(khoa); } } });
    if (p.luaChon?.length) return oChonGiaTri(dinh, gt, { testid: `dt-ts-${p.ten}`, khoa, onDoi: (v) => { if (v !== gt) { luuTs(n.id, { [p.ten]: v }, nhanThamSo(p.nhan)); veLaiForm(khoa); } } });
    const sai = giaTriSai.get(khoa);
    const inp = h("input", { value: sai ?? gt, "data-testid": `dt-ts-${p.ten}`, "data-khoa": khoa, title: p.moTa, inputmode: p.kieu === "so" ? "numeric" : undefined, class: sai !== undefined ? "kb-sai" : undefined,
      placeholder: (p.batBuoc ? "bắt buộc" : "không bắt buộc") + (THAM_SO_XOAY.has(p.ten) ? " — nhiều từ khoá cách nhau bằng dấu |" : "") });
    let daGui = sai ?? gt;
    let soLucGui = soViec; // số việc sửa đã xếp lúc gửi daGui
    const gui1 = (): void => {
      const v = inp.value;
      // không đổi từ lần gửi trước (Enter rồi rời ô → không gửi lại; giá trị sai đã báo → không báo lại) — TRỪ giá trị bị từ chối vì ô KHÁC (vd "Nghỉ từ" 10 khi "Đến" còn 5)
      // mà SAU lần gửi đó đã có việc sửa khác (đã sửa "Đến" 20, kể cả còn đang lưu): gõ lại đúng giá trị đó + Enter phải gửi lại — hàng đợi gửi SAU việc kia nên máy chủ xét
      // trên sơ đồ mới (08/10/2026, E2E KB14 — trước đây gõ lại không gửi gì, ô kẹt viền đỏ, người dùng không lưu được "10")
      const doiTuLucSai = giaTriSai.get(khoa) === v && soViec > soLucGui;
      if (v === daGui && !doiTuLucSai) return;
      daGui = v;
      luuTs(n.id, { [p.ten]: v }, p.nhan, khoa, v, inp);
      soLucGui = soViec;
    };
    inp.addEventListener("change", gui1);
    inp.addEventListener("blur", gui1);
    inp.addEventListener("keydown", (e) => { if (e.key === "Enter" && !e.isComposing) gui1(); });
    return h("label", { class: "f kb-ts" }, h("span", {}, p.nhan, nhanKhoangSo(p)), inp, canhBaoSo(inp, p, `dt-khuyen-${p.ten}`, tenMangCua(ctx.banDo(), mang)));
  }

  // ---------- vòng đời ----------
  const roiTrang = (): void => {
    // đóng tab / F5: gửi nốt phần bố cục còn chờ (fetch keepalive sống sót qua việc rời trang)
    const doi = luuBC?.layDoi();
    if (!doi || !q) return;
    try { void fetch(`/api/kich-ban/${encodeURIComponent(layId())}/bo-cuc`, { method: "PUT", credentials: "same-origin", keepalive: true, headers: { "content-type": "application/json; charset=utf-8", accept: "application/json" }, body: JSON.stringify({ nut: doi }) }); } catch { /* không bắt buộc */ }
  };
  addEventListener("pagehide", roiTrang);

  function ve(): void {
    if (daHuy) return;
    const d = ctx.layD();
    if (!d.doThi) return;
    if (!q) khoiTao(d);
    else if (!q.ban && (q.phienBan !== d.phienBan || !trangBangNhau(q.xacNhan, trangTuMayChu(d)))) q.datXacNhan(trangTuMayChu(d), d.phienBan); // đổi từ nơi khác (tải lại / lưu sản phẩm…) khi rảnh → nhận làm bản đã lưu
    if (!canvas) datCanvas(d);
    else dongBo();
    veTrangThaiLuu();
    veTong(); veKeHoach(); veKetQua(); veCongCu();
    if (!canvas) return;
    if (chiDoc()) { /* chỉ đọc: canvas tự ẩn công cụ sửa */ }
  }
  const butDoTuCo = (): BuocDoChay[] => {
    if (!q) return [];
    const t = q.hienThi();
    const ra: BuocDoChay[] = [];
    for (const n of t.nut) { const c = co.get(n.id); if (c?.some((x) => x.muc === "do")) ra.push({ soThuTu: ra.length + 1, tieuDe: tenNutCua(ctx.banDo(), t.nenTang, n), loi: c.filter((x) => x.muc === "do").map((x) => x.loi).join(" · "), nutId: n.id }); }
    return ra;
  };
  return {
    ve,
    huy: () => {
      if (daHuy) return;
      daHuy = true;
      removeEventListener("pagehide", roiTrang);
      removeEventListener("beforeunload", canhBaoRoi);
      window.clearTimeout(henDongBo);
      void luuBC?.xa();
      void q?.luuNgay(); // rời trang trong app: lưu NGAY phần còn chờ (kể cả đang chờ thử lại) — không bỏ thao tác
      canvas?.huy(); canvas = null;
      the.remove();
    },
    ban: () => !!q?.ban,
    choXong: async () => { await q?.choXong(); },
    buocDo: butDoTuCo,
    nhayToi,
    soBuocTuDong: () => (q?.hienThi().nut ?? []).filter((n) => n.tuDuyet === true).length,
    chuaLuu,
  };
}
